import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the DurationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'duration',
  standalone: true,
})
export class DurationPipe implements PipeTransform {
  /**
   * Takes a value and makes it to hh:mm.
   */

  transform(value: number): string {
    let hours: number | string = Math.floor(value / 60);
    let minutes: number | string = value - hours * 60;

    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    return hours + 'h' + minutes;
  }
}
